import { render, staticRenderFns } from "./ExhibitionMain.vue?vue&type=template&id=f8c7e5fa&"
import script from "./ExhibitionMain.vue?vue&type=script&lang=js&"
export * from "./ExhibitionMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8c7e5fa')) {
      api.createRecord('f8c7e5fa', component.options)
    } else {
      api.reload('f8c7e5fa', component.options)
    }
    module.hot.accept("./ExhibitionMain.vue?vue&type=template&id=f8c7e5fa&", function () {
      api.rerender('f8c7e5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/Exhibition/ExhibitionMain.vue"
export default component.exports